// src/components/Loader.js
import React from 'react';
import './Loader.css'; // Add your loader styles here

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="spinner"></div>
    </div>
  );
};

export default Loader;
